/**
 * Reads a File/Blob into a base64 data URI. Used across the post-ad flow for
 * inline previews and single-request uploads to the shared media endpoint.
 */
export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
